import { useQuery } from "@tanstack/react-query";
import { api } from "./api";
import type { OrgSummary } from "@/components/layout/OrgSwitcher";

export function useOrgs() {
  return useQuery({
    queryKey: ["orgs"],
    queryFn: async () => {
      const r = await api.get<{ orgs: OrgSummary[] }>("/orgs");
      return r.orgs;
    },
    staleTime: 60_000,
  });
}
